import React from 'react';
import './SectionLabel.css'

const SectionLabel = (props) => {
    return ( 
        <p className='SectionLabel'>
            {props.SectionLabel}
        </p>
     );
}
 
export default SectionLabel;